<template>
  <v-container>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- filter -->
    <v-row>
      <v-col cols="12" md="3">
        <AutocompleteComp @change="change_anio()" :items="anio_lectivo" v-model="filter.id_anio_lectivo"
          item-text="nom_anolectivo" item-value="id" text-label="Año lectivo" />
      </v-col>
      <v-col cols="12" md="3">
        <AutocompleteComp @change="change_nivel()" :items="filter.niveles" v-model="filter.id_nivel"
          item-text="desc_nivel" item-value="id_nivel" text-label="Nivel" />
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-end align-center">
        <ButtonComp @click="crear()" icon-but="fas fa-plus" text-button="Crear criterios" normal-button />
      </v-col>

      <v-col cols="12">
        <ComundataTablecomp :headers="CriteriosconductasHeaders" :items="filteredCopyDesserts">
          <template v-slot:editar="{ item }">
            <ButtonComp @click="on_updated(item)" edit-button tooltip-text="Editar criterio" />
          </template>

          <template v-slot:eliminar="{ item }">
            <ButtonComp @click="on_deleted(item)" delete-button tooltip-text="Eliminar criterio" />
          </template>
        </ComundataTablecomp>
      </v-col>

    </v-row>



    <!-- type: 1->guardar, 2-> actualizar, 3-> eliminar -->
    <GlobalDialog v-if="confirm.type == 1" Confirmdialog v-model="confirm_modal" @close-modal="confirm_modal = false"
      @confirm-item="registrar(true)" @cancel-item="registrar(false)">
      <template v-slot:body>
        <h2 class="font-font-weight-bold text-center">
          {{ confirm.title }}
        </h2>
      </template>
    </GlobalDialog>

    <GlobalDialog v-else-if="confirm.type == 2" Deletedialog v-model="delete_modal" titleWindow="Eliminar criterio"
      @close-modal="delete_modal = false" @delete-item="eliminar(true)" @cancel-item="delete_modal = false">
      <template v-slot:body>
        {{ confirm.title }}
      </template>
    </GlobalDialog>



    <!-- dialog create -->
    <v-row>
      <!-- <v-dialog v-model="dialog.active" persistent max-width="700px"> -->
      <v-form ref="formDatos" lazy-validation class="card white pb-3">
        <GlobalDialog :title="dialog.title" @close-modal="create_modal = false" v-model="create_modal" maxWidth="1500">
          <template v-slot:body>
            <v-row v-model="dialog.isvalid">
              <v-col cols="12" sm="3" md="6">
                <v-text-field label="Año lectivo" v-model="setreg.anio_lectivo" readonly></v-text-field>
              </v-col>

              <v-checkbox class="d-none" v-model="selectedNiveles" :rules="[rules.requiredNiveles]"></v-checkbox>

              <v-col v-for="nivel in niveles" :key="nivel.id_nivel" class="d-flex justify-center" cols="4" sm="3" md="2">
                <v-checkbox :label="nivel.desc_nivel" :value="nivel.id_nivel" v-model="selectedNiveles"
                  :disabled="dialog.update" :rules="[rules.requiredNiveles]"></v-checkbox>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field label="N.° de criterio" v-model="setreg.numero" required
                  :rules="[rules.required]"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field label="Nombre del criterio" v-model="setreg.nombre" required
                  :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-textarea v-model="setreg.indicador" label="Indicador" rows="3" type="text" textarea required
                  :rules="[rules.required]"></v-textarea>
              </v-col>
            </v-row>
          </template>
          <template v-slot:actions>
            <v-spacer></v-spacer>
            <ButtonComp v-if="dialog.update" @click="actualizar()" textButton="Guardar cambios" iconBut="fas fa-save"
              :loading="dialog.animated" normalButton>
            </ButtonComp>
            <!-- :loading="dialog.animated" -->
            <ButtonComp v-else @click="save()" textButton="Guardar" iconBut="fas fa-save" normalButton>
            </ButtonComp>

          </template>
        </GlobalDialog>

      </v-form>
      <!-- </v-dialog> -->
    </v-row>

    <!-- grid -->

  </v-container>
</template>
<script>
import axios from "@/helpers/axios";
import { mapMutations, mapActions } from "vuex";
import GlobalDialog from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import { CriteriosconductasHeaders } from '../../../../helpers/headersTable';



export default {
  name: "CriterioConduta",
  components: {
    GlobalDialog,
    ButtonComp,
    ComundataTablecomp,
    AutocompleteComp,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Campo requerido",
        selectReq: (value) =>
          !!value || "Debe seleccionar un campo de la lista",
        requiredNiveles: value => (value && value.length > 0) || '¡Debes seleccionar al menos un nivel!'
      },
      delete_modal: false,
      CriteriosconductasHeaders,
      create_modal: false,
      confirm_modal: false,
      dialog: {
        active: false,
        confirm: false,
        title: "CREAR CRITERIO DE CONDUCTA",
        animated: false,
        isValid: false,
        update: false,
      },
      confirm: {
        active: false,
        state: false,
        title: "",
        type: 0,
      },
      filter: {
        id_anio_lectivo: sessionStorage.id_ano_lectivo,
        id_periodo: 0,
        id_nivel: 0,
        niveles: [],
        periodo: [],
      },
      anio_lectivo: [],
      niveles: [],
      periodo: [],

      desserts: [],
      copyDesserts: [],
      parameters: {
        id_colegio: sessionStorage.id_colegio,
        id_periodo: 0,
        id_nivel: 0,
        id_anio_lectivo: sessionStorage.id_ano_lectivo,
        id_usu: sessionStorage.id,
      },
      parametros: {
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_colegio_adm_nivel: sessionStorage.id_colegio,
      },
      setreg: {
        id_anio_lectivo: sessionStorage.id_ano_lectivo,
        anio_lectivo: "",
        id: 0,
        numero: "",
        nombre: "",
        indicador: "",
        id_periodo: 0,
        id_nivel: [],
        id_usu: sessionStorage.id,
      },
      selectedNiveles: [],
    };
  },
  computed: {

    filteredCopyDesserts() {
      if (!this.filter.id_nivel) {
        return this.copyDesserts
      }
      return this.copyDesserts.filter(element => element.id_nivel == this.filter.id_nivel)
    }

  },
  mounted() {
    this.resetForm();
  },
  watch: {
    dialog: function () {
      if (this.dialog) {
        this.resetForm();
      }
    },
    selectedNiveles: function (newValues) {
      if (newValues.length > 0) {
        this.setreg.id_nivel = [...newValues];
      } else {
        this.setreg.id_nivel = 0;
      }
    },
  },
  created() {
    this.ano_lectivo();
    this.initialData();
    this.get_nivel();
    this.get_periodo();
    this.resetForm();
  },
  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    clear() {
      this.setreg.id_anio_lectivo = sessionStorage.id_ano_lectivo;
      //this.setreg.anio_lectivo = "";
      this.filter.id_periodo = 0;
      this.filter.id_nivel = 0;
      this.selectedNiveles = []
      this.setreg.id_periodo = 0;
      this.setreg.selectedNiveles = 0;
      this.setreg.id = 0;
      this.setreg.numero = "";
      this.setreg.nombre = "";
      this.setreg.indicador = "";
      this.create_modal = false;
      // this.delete_modal = false;
      this.dialog.update = false;
      this.get_periodo();

      this.resetForm();
    },
    resetForm() {
      if (this.$refs.formDatos != undefined) {
        this.$refs.formDatos.resetValidation();
      }
    },
    crear() {
      // this.clear();
      this.create_modal = true;
      this.dialog.title = "Crear criterio de conducta";
      // setTimeout(() => {
      //   this.dialog.active = !this.dialog.active;
      // }, 100);
    },
    //listar registros d ecriterios
    async initialData() {
      try {

        const response = await axios.post(
          `/administrativo/manualidades/criterios/`,
          {
            id_ano_lectivo: this.filter.id_anio_lectivo,
            id_periodo: this.filter.id_periodo,
            id_nivel: this.filter.id_nivel,
          }
        );
        this.desserts = response.data;
        this.copyDesserts = response.data;

      } catch (e) {
        console.log("Error al cargar la data inical", e);
      }
    },
    // listar año lectivo
    async ano_lectivo() {
      try {
        const response = await axios.get(
          `/administrativo/manualidades/criterios/anolectivo/${this.parameters.id_colegio}`
        );
        this.filter.id_anio_lectivo = response.data[0].id;
        this.setreg.anio_lectivo = response.data[0].nom_anolectivo;
        this.anio_lectivo = response.data;
      } catch (e) {
        console.log("Error al solicitar el año lectivo", e);
      }
    },
    async get_nivel() {
      let params = this.parametros;
      try {
        let response = await axios.post(
          "/administrativo/nivel/niveladmin/",
          params
        );
        this.filter.niveles = response.data;

        // if (response.data.length > 0) {
        //   this.filter.niveles.unshift({ id_nivel: 0, desc_nivel: "Todos" });
        // } else {
        //   this.filter.niveles.push({ id_nivel: 0, desc_nivel: "Todos" });
        // }
        this.niveles = [...response.data];
        // this.niveles.splice(0, 1);
      } catch (error) {
        console.log("Error al obtener los niveles", error);
      }
    },

    // listar periodo por año lectivo
    async get_periodo(filter = true) {
      try {
        if (filter) {
          const response = await axios.post(
            `/administrativo/manualidades/criterios/periodo/`,
            {
              id_colegio: this.parameters.id_colegio,
              id_anio_lectivo: this.filter.id_anio_lectivo,
              id_nivel: this.filter.id_nivel,
            }
          );
          this.filter.periodo = response.data;
          if (response.data.length > 0) {
            this.filter.periodo.unshift({ id: 0, nombre_periodo: "Todos" });
          } else {
            this.filter.periodo.push({ id: 0, nombre_periodo: "Todos" });
          }
        } else {
          const response = await axios.post(
            `/administrativo/manualidades/criterios/periodo/`,
            {
              id_colegio: this.parameters.id_colegio,
              id_anio_lectivo: sessionStorage.id_ano_lectivo,
              id_nivel: this.setreg.id_nivel,
            }
          );
          this.periodo = response.data;
          // this.periodo.splice(0, 1);
          // this.filter.periodo = response.data;
          //  if (response.data.length > 0) {
          //    this.filter.periodo.unshift({ id: 0, nombre_periodo: "Todos" });
          //  } else {
          //    this.filter.periodo.push({ id: 0, nombre_periodo: "Todos" });
          //  }
          //  this.periodo = [...response.data];
          //  this.periodo.splice(0, 1);
        }
      } catch (e) {
        console.log("Error al obtener los periodos", e);
      }
    },
    nivel_periodo() {
      this.get_periodo(false);
    },
    change_periodo() {
      setTimeout(() => {
        this.initialData();
      }, 100);
    },

    change_anio() {
      this.get_periodo();
      setTimeout(() => {
        this.initialData();
      }, 100);
    },
    change_nivel() {
      setTimeout(() => {
        this.initialData();
      }, 100);
    },

    // confirmar registro
    confirmData() {
      this.dialog.animated = true;
      this.confirm.active = true;
      this.dialog.animated = false;
    },
    // acciones para activar modal confirm

    save() {
      if (this.$refs.formDatos.validate()) {
        this.confirm_modal = true;
        // this.confirm.active = true;
        this.confirm.type = this.setreg.id == 0 ? 1 : 0;
        this.confirm.title =
          this.setreg.id == 0
            ? "¿Desea permanecer y registrar otro criterio de conducta?"
            : "";
      }
    },
    //event actions
    async on_updated(item) {
      try {
        const response = await axios.post(
          `/administrativo/manualidades/criterios/${item.id}`,
          {
            id_ano_lectivo: this.filter.id_anio_lectivo,
          }
        );
        const { data } = response;
        if (data) {
          this.setreg.id = data.id;
          this.setreg.numero = data.numero;
          this.setreg.nombre = data.nombre;
          this.setreg.indicador = data.indicador;
          this.setreg.id_periodo = data.id_periodo;
          this.setreg.id_nivel = data.id_nivel;
          this.setreg.id_usu = sessionStorage.id;
          this.selectedNiveles = [item.id_nivel]
          this.get_periodo(false);
          this.create_modal = true;
          // this.dialog.active = true;
          this.dialog.update = true;
          this.dialog.title = " Editar criterio de conducta";
        } else {
          this.setEnviarMens({
            tipo: "S",
            mensaje: "ocurrio error al obtener datos",
            tiempo: null,
          });
        }
      } catch (e) {
        console.log("Error al actualizar los datos", e);
      }
    },

    // acciones registrar, actualizar, eliminra
    registrar(state = false) {

      axios
        .post("/administrativo/manualidades/criterios/create/", this.setreg)
        .then((response) => {
          if (state) {
            this.confirm.active = false;
          } else {
            // this.confirm.active = false;
            this.dialog.active = false;
          }
          this.confirm.type = 0;
          this.confirm.title = "";

          this.clear();
          this.initialData();

          const { data } = response;
          if (data.success) {
            this.setEnviarMens({
              tipo: "S",
              mensaje: data.message,
              tiempo: null,
            });
          } else {
            this.setEnviarMens({
              tipo: "E",
              mensaje: data.message,
              tiempo: null,
            });
          }
        })
        .catch((e) => {
          this.setEnviarMens({
            tipo: "E",
            mensaje: e,
            tiempo: null,
          });
        });
    },
    actualizar() {
      if (this.$refs.formDatos.validate()) {
        axios
          .put(
            `/administrativo/manualidades/criterios/${this.setreg.id}`,
            this.setreg
          )
          .then((response) => {
            const { data } = response;
            if (data.success) {
              this.confirm.active = false;
              this.dialog.active = false;
              this.dialog.update = false;
              this.confirm.type = 0;
              this.confirm.title = "";

              this.clear();
              this.initialData();
              this.setEnviarMens({
                tipo: "S",
                mensaje: data.message,
                tiempo: null,
              });
            } else {
              this.setEnviarMens({
                tipo: "E",
                mensaje: data.message,
                tiempo: null,
              });
            }
          })
          .catch((e) => {
            this.setEnviarMens({
              tipo: "E",
              mensaje: e,
              tiempo: null,
            });
          });
      }
    },
    on_deleted(item) {
      // this.clear();
      this.delete_modal = true;
      // this.confirm.active = true;
      this.confirm.type = 2;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.setreg.id = item.id;
    },
    async eliminar() {
      await axios
        .post(`/administrativo/manualidades/criterios/delete/${this.setreg.id}`)
        .then((response) => {
          // this.confirm.active = false;

          this.dialog.active = false;
          this.confirm.type = 0;
          this.confirm.title = "";
          this.setreg.id = 0;

          this.clear();
          this.initialData();
          const { data } = response;

          if (data.success) {
            this.setEnviarMens({
              tipo: "S",
              mensaje: data.message,
              tiempo: null,
            });
          } else {
            this.setEnviarMens({
              tipo: "E",
              mensaje: data.message,
              tiempo: null,
            });
          }
        });
    },
  },
};
</script>